import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CreditCustomersPage, parseDetailTab } from '@/domains/credit';

// El router puede coaccionar un id numérico: se acepta y se normaliza a texto.
// `.catch(undefined)` descarta solo el parámetro inválido, nunca los dos.
const deepLinkParam = z
    .union([z.string(), z.number()])
    .transform(String)
    .optional()
    .catch(undefined);

const searchSchema = z.object({
    cliente: deepLinkParam,
    tab: deepLinkParam,
});

export type CreditCustomersSearch = z.infer<typeof searchSchema>;

/** Deep links: `?cliente=` abre esa ficha y `?tab=` su pestaña. Lo que no valida se ignora. */
export function parseCreditCustomersSearch(search: Record<string, unknown>): CreditCustomersSearch {
    const parsed = searchSchema.safeParse(search);
    return parsed.success ? parsed.data : {};
}

// Ruta estática: gana sobre la dinámica hermana `$section`, que sigue cubriendo el resto.
export const Route = createFileRoute('/_backoffice/credit/customers')({
    validateSearch: parseCreditCustomersSearch,
    component: CreditCustomers,
});

function CreditCustomers() {
    const { cliente, tab } = Route.useSearch();
    return <CreditCustomersPage customerId={cliente} tab={parseDetailTab(tab)} />;
}
